module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-05-66c6ae9af3c02b7b41506d7107ceeefc.png";